import { axios } from "../../helpers/axios";
import { isAuth } from "../../helpers/cookies";
import { JOB_URL, GET_JOB_MESSAGES_URL, GET_JOB_LIST, SEND_PROOF, PROOF_LOG_TABLE, VIEW_PROOF, PROOF_APPROVE, PROOF_REJECT, SIDEBAR_MENU_URL, ADD_PROOF_COMMENTS_URL, ASSIGN_JOB_URL } from "./jobConstants";
import qs from "qs";

export const api_get_company_job_form_url = async (company_id, process_id) => {
  return axios.get(JOB_URL + '/' + company_id + 'forms' + '/' + process_id);
};

export const api_create_send_message__url = async (job_id, action_type, data) => {
  return axios.post(JOB_URL + '/' + job_id + '/send-message',
    data,
    {
      params: { action_type },
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
};

export const api_get_job_messages_url = async (job_id) => {
  return axios.get(GET_JOB_MESSAGES_URL + job_id);
};

export const api_submit_job_url = async (company_id, process_id, formData, stage_id) => {
  let url = JOB_URL + '/' + company_id + '/' + 'process' + '/' + process_id + '/submit';

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };

  if (stage_id) {
    config.params = { stage_id };
  }

  return axios.post(url, formData, config);
}

export const api_get_job_detail_url = async (job_id) => {
  return axios.get(JOB_URL + '/details/' + job_id);
};

export const api_update_job_url = async (job_id, job_data) => {
  return axios.put(JOB_URL + '/update/' + job_id, job_data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const api_download_file_url = async (job_id, file_key, d_type) => {
  return axios.get(JOB_URL + '/download', {
    params: { job_id, file_key, d_type }
  });
};

export const api_download_zip_file_url = async (job_id, comp_file_list) => {
  return axios.get(JOB_URL + '/zip_download', {
    params: { job_id, comp_file_list },
    responseType: "blob"
  });
};
export const api_job_list_url = async (company_id, process_id, stage_id, skip = 0, limit = 10, qn, column, assigned_to) => {
  const params = { skip, limit, qn, column };
  if (assigned_to !== undefined && assigned_to !== null) {
    params.assigned_to = assigned_to;
  }
  return axios.get(company_id + GET_JOB_LIST + '/' + process_id + '/' + stage_id, {
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  })
}

export const api_assign_job = async (job_id, data) => {
  return axios.post(`${ASSIGN_JOB_URL}/${job_id}/assign`, data);
};

export const api_send_proof = async (data) => {
  return axios.post(SEND_PROOF, data)
}

export const api_get_proof_log = async (payload) => {
  return axios.get(PROOF_LOG_TABLE, {
    params: payload?.job_id ? { job_id: payload.job_id } : {}
  })
}

export const api_viewproof = async (proof_id) => {
  return axios.get(VIEW_PROOF, {
    params: { proof_id }
  });
};

export const api_proof_approve = async ({
  proof_id,
  approved_proof_id,
  approved_proof_option,
}) => {
  return axios.put(PROOF_APPROVE, null, {
    params: { proof_id, approved_proof_id, approved_proof_option },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const api_proof_reject = async ({ proof_id, comment }) => {
  return axios.put(PROOF_REJECT, null, {
    params: { proof_id, comment },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};



export const api_get_sidebar_menu = async (process_id, qn, column) => {
  return axios.get(SIDEBAR_MENU_URL, {
    params: { process_id, qn, column },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
    params: { process_id },
  });
};

export const api_add_proof_comments = async (proof_id, proof_comments) => {
  return axios.post(`${ADD_PROOF_COMMENTS_URL}/${proof_id}/`, {
    proof_comments: proof_comments,

  });
};

export const api_get_job_count_by_user = async (user_id) => {
  return await axios.get(`/jobcountuser/${user_id}`);
};